var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", [
          _c("p", {
            staticClass: "icon-jujue closeBtn",
            on: { click: _vm.routerBack },
          }),
        ]),
        _c(
          "el-row",
          { attrs: { type: "flex", align: "middle" } },
          [
            _vm.detailForm.status == 1 || _vm.detailForm.status == 3
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.RMC_PROT_SCORE_SAVE,
                        expression: "RMC_PROT_SCORE_SAVE",
                      },
                    ],
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.saveData("detailForm")
                      },
                    },
                  },
                  [_vm._v("保存")]
                )
              : _vm._e(),
            _vm.detailForm.status == 1 || _vm.detailForm.status == 3
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.RMC_PROT_SCORE_SUBMIT,
                        expression: "RMC_PROT_SCORE_SUBMIT",
                      },
                    ],
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.submitData("detailForm")
                      },
                    },
                  },
                  [_vm._v("提交")]
                )
              : _vm._e(),
            _vm.detailForm.status == 2
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.RMC_PROT_SCORE_APPROVE,
                        expression: "RMC_PROT_SCORE_APPROVE",
                      },
                    ],
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.cqsSave },
                  },
                  [_vm._v("保存")]
                )
              : _vm._e(),
            _vm.detailForm.status == 2
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.RMC_PROT_SCORE_APPROVE,
                        expression: "RMC_PROT_SCORE_APPROVE",
                      },
                    ],
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.approve("detailForm")
                      },
                    },
                  },
                  [_vm._v("批准")]
                )
              : _vm._e(),
            _vm.detailForm.status == 2
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.RMC_PROT_SCORE_RETURN,
                        expression: "RMC_PROT_SCORE_RETURN",
                      },
                    ],
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.rejectBatch },
                  },
                  [_vm._v("退回")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "el-form",
          {
            ref: "detailForm",
            staticClass: "searchForm",
            attrs: {
              model: _vm.detailForm,
              rules: _vm.rules,
              "label-position": _vm.labelPosition,
              "label-width": "120px",
            },
          },
          [
            _c(
              "div",
              { staticClass: "handle-box" },
              [
                _c(
                  "div",
                  {
                    staticClass: "info_box_title",
                    staticStyle: {
                      "padding-left": "10px",
                      "box-sizing": "border-box",
                    },
                  },
                  [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [
                      _vm._v("RMC Protein"),
                    ]),
                  ]
                ),
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-top": "8px" },
                    attrs: { align: "middle" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "单号", prop: "oddNo" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailForm.oddNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailForm, "oddNo", $$v)
                                },
                                expression: "detailForm.oddNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "评价期", prop: "appraisePeriod" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: "",
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择(支持多选)",
                                },
                                model: {
                                  value: _vm.detailForm.appraisePeriod,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailForm,
                                      "appraisePeriod",
                                      $$v
                                    )
                                  },
                                  expression: "detailForm.appraisePeriod",
                                },
                              },
                              _vm._l(_vm.allDate, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Category3",
                              prop: "category3Code",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: "",
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailForm.category3Code,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailForm,
                                      "category3Code",
                                      $$v
                                    )
                                  },
                                  expression: "detailForm.category3Code",
                                },
                              },
                              _vm._l(_vm.category3List, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.object,
                                    value: item.key,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Sponsor", prop: "sponsorName" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailForm.sponsorName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailForm, "sponsorName", $$v)
                                },
                                expression: "detailForm.sponsorName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "ASL", prop: "aslName" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "", clearable: "" },
                              model: {
                                value: _vm.detailForm.aslName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailForm, "aslName", $$v)
                                },
                                expression: "detailForm.aslName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "国内/国外",
                              prop: "domesticOrOverseas",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: "",
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailForm.domesticOrOverseas,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailForm,
                                      "domesticOrOverseas",
                                      $$v
                                    )
                                  },
                                  expression: "detailForm.domesticOrOverseas",
                                },
                              },
                              _vm._l(
                                _vm.domesticOrOverseas,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.object,
                                      value: item.key,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: "",
                                  disabled: "",
                                  filterable: "",
                                  placeholder: "请选择(支持多选)",
                                },
                                model: {
                                  value: _vm.detailForm.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detailForm, "status", $$v)
                                  },
                                  expression: "detailForm.status",
                                },
                              },
                              _vm._l(_vm.statusList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 6 } }),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "退回原因", prop: "rejectReason" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailForm.rejectReason,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailForm, "rejectReason", $$v)
                                },
                                expression: "detailForm.rejectReason",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-table",
              {
                ref: "plxTable",
                staticClass: "setTable",
                attrs: {
                  "span-method": _vm.arraySpanMethod,
                  data: _vm.detailForm.detailList,
                  "max-height": "500",
                  "show-overflow": "tooltip",
                  "highlight-current-row": "",
                },
                on: { "selection-change": _vm.selectionChange },
              },
              [
                _c(
                  "el-table-column",
                  { attrs: { label: "", align: "center" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        label: "Rating Category",
                        align: "center",
                        width: "120",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "wt1View",
                        label: "Wt. Food Brand",
                        align: "center",
                        width: "80",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "wt2View",
                        label: "Wt. Product",
                        align: "center",
                        width: "80",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          prop: "standard1",
                          label: "High",
                          align: "center",
                          width: "160",
                          "show-overflow-tooltip": "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "standard1",
                            label: "10",
                            align: "center",
                            width: "160",
                            "show-overflow-tooltip": "",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          prop: "standard2",
                          label: "Medium High",
                          align: "center",
                          width: "160",
                          "show-overflow-tooltip": "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "standard2",
                            label: "8",
                            align: "center",
                            width: "160",
                            "show-overflow-tooltip": "",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          prop: "standard3",
                          label: "Medium",
                          align: "center",
                          width: "160",
                          "show-overflow-tooltip": "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "standard3",
                            label: "6",
                            align: "center",
                            width: "160",
                            "show-overflow-tooltip": "",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          prop: "standard4",
                          label: "Medium Low",
                          align: "center",
                          width: "160",
                          "show-overflow-tooltip": "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "standard4",
                            label: "3",
                            align: "center",
                            width: "160",
                            "show-overflow-tooltip": "",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          prop: "standard5",
                          label: "Low",
                          align: "center",
                          width: "160",
                          "show-overflow-tooltip": "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "standard5",
                            label: "0",
                            align: "center",
                            width: "160",
                            "show-overflow-tooltip": "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table-column",
                  { attrs: { label: "供应商自评", align: "center" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "supplierScore1",
                        label: "Food Brand Association|(whole company)",
                        "render-header": _vm.renderheader,
                        align: "center",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              (_vm.detailForm.status == 1 ||
                                _vm.detailForm.status == 3) &&
                              scope.$index !=
                                _vm.detailForm.detailList.length - 1 &&
                              scope.$index !=
                                _vm.detailForm.detailList.length - 2 &&
                              _vm.isSet
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "detailList." +
                                          scope.$index +
                                          ".supplierScore1",
                                        rules: scope.row.wt1
                                          ? _vm.rules.supplierScore1
                                          : "",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: scope.row.wt1
                                            ? false
                                            : true,
                                          placeholder: "请输入内容",
                                        },
                                        on: {
                                          input: function ($event) {
                                            scope.row.supplierScore1 =
                                              scope.row.supplierScore1.replace(
                                                /[^\d]/g,
                                                ""
                                              )
                                          },
                                          blur: function ($event) {
                                            return _vm.setCurrent(scope.row, 1)
                                          },
                                        },
                                        model: {
                                          value: scope.row.supplierScore1,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "supplierScore1",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.supplierScore1",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row.supplierScore1)),
                                  ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "supplierScore2",
                        label: "Product Safety|(McDssupplyonly)",
                        "render-header": _vm.renderheader,
                        align: "center",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              (_vm.detailForm.status == 1 ||
                                _vm.detailForm.status == 3) &&
                              scope.$index !=
                                _vm.detailForm.detailList.length - 1 &&
                              scope.$index !=
                                _vm.detailForm.detailList.length - 2 &&
                              _vm.isSet
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "detailList." +
                                          scope.$index +
                                          ".supplierScore2",
                                        rules: scope.row.wt2
                                          ? _vm.rules.supplierScore2
                                          : "",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: scope.row.wt2
                                            ? false
                                            : true,
                                          placeholder: "请输入内容",
                                        },
                                        on: {
                                          input: function ($event) {
                                            scope.row.supplierScore2 =
                                              scope.row.supplierScore2.replace(
                                                /[^\d]/g,
                                                ""
                                              )
                                          },
                                          blur: function ($event) {
                                            return _vm.setCurrent(scope.row, 2)
                                          },
                                        },
                                        model: {
                                          value: scope.row.supplierScore2,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "supplierScore2",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.supplierScore2",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row.supplierScore2)),
                                  ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "supplierFacts",
                        label: "Facts",
                        align: "center",
                        width: "160",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              (_vm.detailForm.status == 1 ||
                                _vm.detailForm.status == 3) &&
                              scope.$index !=
                                _vm.detailForm.detailList.length - 1 &&
                              scope.$index !=
                                _vm.detailForm.detailList.length - 2 &&
                              _vm.isSet
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "detailList." +
                                          scope.$index +
                                          ".supplierFacts",
                                        rules: _vm.rules.supplierFacts,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "stretchNone",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "textarea",
                                          maxlength: "1000",
                                          autosize: { minRows: 4, maxRows: 4 },
                                          rows: 4,
                                        },
                                        model: {
                                          value: scope.row.supplierFacts,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "supplierFacts",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.supplierFacts",
                                        },
                                      }),
                                      (scope.row.parentId ? true : false)
                                        ? _c("i", {
                                            staticClass: "el-icon-edit-outline",
                                            staticStyle: {
                                              position: "absolute",
                                              right: "10px",
                                              bottom: "10%",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.openDialog(
                                                  scope.row,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: scope.row.supplierFacts,
                                        placement: "top-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "inline-block",
                                            maxHeight: "180px",
                                            padding: "20px 0px",
                                            "box-sizing": "border-box",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(scope.row.supplierFacts)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c(
                  "el-table-column",
                  { attrs: { label: "CQS评分", align: "center" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "cqsScore1",
                        label: "Food Brand Association|(whole company)",
                        "render-header": _vm.renderheader,
                        align: "center",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.detailForm.status == 2 &&
                              scope.$index !=
                                _vm.detailForm.detailList.length - 1 &&
                              scope.$index !=
                                _vm.detailForm.detailList.length - 2 &&
                              _vm.isCqs
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "detailList." +
                                          scope.$index +
                                          ".cqsScore1",
                                        rules: scope.row.wt1
                                          ? _vm.rules.cqsScore1
                                          : "",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: scope.row.wt1
                                            ? false
                                            : true,
                                          placeholder: "请输入内容",
                                        },
                                        on: {
                                          input: function ($event) {
                                            scope.row.cqsScore1 =
                                              scope.row.cqsScore1.replace(
                                                /[^\d]/g,
                                                ""
                                              )
                                          },
                                          blur: function ($event) {
                                            return _vm.setCqsCurrent(
                                              scope.row,
                                              1
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.cqsScore1,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "cqsScore1",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.cqsScore1",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row.cqsScore1)),
                                  ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "cqsScore2",
                        label: "Product Safety|(McDssupplyonly)",
                        "render-header": _vm.renderheader,
                        align: "center",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.detailForm.status == 2 &&
                              scope.$index !=
                                _vm.detailForm.detailList.length - 1 &&
                              scope.$index !=
                                _vm.detailForm.detailList.length - 2 &&
                              _vm.isCqs
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "detailList." +
                                          scope.$index +
                                          ".cqsScore2",
                                        rules: scope.row.wt2
                                          ? _vm.rules.cqsScore2
                                          : "",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: scope.row.wt2
                                            ? false
                                            : true,
                                          placeholder: "请输入内容",
                                        },
                                        on: {
                                          input: function ($event) {
                                            scope.row.cqsScore2 =
                                              scope.row.cqsScore2.replace(
                                                /[^\d]/g,
                                                ""
                                              )
                                          },
                                          blur: function ($event) {
                                            return _vm.setCqsCurrent(
                                              scope.row,
                                              2
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.cqsScore2,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "cqsScore2",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.cqsScore2",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row.cqsScore2)),
                                  ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    !_vm.isSupplier
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "cqsFacts",
                            label: "Facts",
                            align: "center",
                            width: "160",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.detailForm.status == 2 &&
                                    scope.$index !=
                                      _vm.detailForm.detailList.length - 1 &&
                                    scope.$index !=
                                      _vm.detailForm.detailList.length - 2 &&
                                    _vm.isCqs
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "detailList." +
                                                scope.$index +
                                                ".cqsFacts",
                                              rules: _vm.rules.cqsFacts,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "stretchNone",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "textarea",
                                                maxlength: "1000",
                                                autosize: {
                                                  minRows: 4,
                                                  maxRows: 4,
                                                },
                                                rows: 4,
                                              },
                                              model: {
                                                value: scope.row.cqsFacts,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "cqsFacts",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.cqsFacts",
                                              },
                                            }),
                                            (scope.row.parentId ? true : false)
                                              ? _c("i", {
                                                  staticClass:
                                                    "el-icon-edit-outline",
                                                  staticStyle: {
                                                    position: "absolute",
                                                    right: "10px",
                                                    bottom: "10%",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.openCqsDialog(
                                                        scope.row,
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content: scope.row.cqsFacts,
                                              placement: "top-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "inline-block",
                                                  maxHeight: "180px",
                                                  padding: "20px 0px",
                                                  "box-sizing": "border-box",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.cqsFacts)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2839474725
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _vm._m(0),
            (_vm.detailForm.status == 1 || _vm.detailForm.status == 3) &&
            _vm.isSet
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.RMC_PROT_SCORE_UPLOAD,
                        expression: "RMC_PROT_SCORE_UPLOAD",
                      },
                    ],
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.openFile },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.selectFile")) + " ")]
                )
              : _vm._e(),
            _c(
              "el-table",
              {
                ref: "plxTable",
                attrs: {
                  data: _vm.fileTable,
                  "max-height": "500",
                  "show-overflow": "ellipsis",
                  "highlight-current-row": "",
                },
                on: { "selection-change": _vm.selectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "附件名称",
                    prop: "documentName",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.onDownload(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.documentName))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "附件描述",
                    align: "center",
                    prop: "docComments",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: scope.row.docComments,
                                placement: "top-start",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    maxHeight: "80px",
                                    padding: "10px 0px",
                                    "box-sizing": "border-box",
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.docComments))]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "上传人", align: "center", prop: "userName" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "上传时间",
                    align: "center",
                    prop: "createDate",
                  },
                }),
                (_vm.detailForm.status == 1 || _vm.detailForm.status == 3) &&
                _vm.isSet
                  ? _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        align: "center",
                        prop: "updateDate",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("i", {
                                  staticClass: "el-icon-delete",
                                  staticStyle: { color: "red" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delFile(scope.row)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2759813660
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "提示",
              visible: _vm.dialogVisible,
              width: "30%",
              "before-close": _vm.handleClose,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _vm.dialogVisible
              ? _c("uploadFile", {
                  attrs: { headerData: _vm.detailForm },
                  on: { close: _vm.handleClose },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "",
              visible: _vm.addDialog,
              width: "60%",
              "before-close": _vm.closeFactsDialog,
            },
            on: {
              "update:visible": function ($event) {
                _vm.addDialog = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header-title",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info_box_title",
                    staticStyle: {
                      "padding-left": "10px",
                      "box-sizing": "border-box",
                    },
                  },
                  [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [
                      _vm._v("Facts填写"),
                    ]),
                  ]
                ),
              ]
            ),
            _vm.addDialog
              ? _c("factsDialog", {
                  attrs: { factsInfo: _vm.factsInfo, factsType: _vm.factsType },
                  on: { closeFacts: _vm.closeAddDialog },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "info_box_title",
        staticStyle: { "padding-left": "10px", "box-sizing": "border-box" },
      },
      [
        _c("p", { staticClass: "line" }),
        _c("p", { staticClass: "info_title" }, [_vm._v("附件")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }